import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";

const bannerStyles = {
  container: {
    background: "#F59E0B",
    borderBottom: "2px solid #B45309",
    color: "#1F1300",
    display: "block",
    padding: "10px 16px",
    fontSize: "14px",
    fontWeight: 600,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    height: "auto",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
    zIndex: 6,
  },
  icon: {
    display: "inline-block",
    marginRight: "8px",
    lineHeight: "16px",
  },
  message: {
    lineHeight: "18px",
  },
};

const MaintenanceBanner = ({ maintenance, isBannerActive, bannerId }) => {
  const bannerRef = useRef(null);

  const message =
    (typeof maintenance.bannerMessage === "string"
      ? maintenance.bannerMessage
      : null) ||
    "Portal će biti privremeno nedostupan zbog nadogradnje sustava.";

  useEffect(() => {
    if (!bannerRef.current) return undefined;
    if (!maintenance || !isBannerActive || !bannerId) return undefined;
    const height = bannerRef.current.offsetHeight;
    const root = document.documentElement;
    root.style.setProperty("--maintenance-banner-height", `${height}px`);
    return () => {
      root.style.removeProperty("--maintenance-banner-height");
    };
  }, [maintenance, isBannerActive, bannerId]);

  if (!maintenance || !isBannerActive || !bannerId) return null;

  return (
    <div ref={bannerRef} style={bannerStyles.container}>
      <span style={bannerStyles.icon} aria-hidden="true">
        ⚠️
      </span>
      <span
        style={bannerStyles.message}
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  maintenance: state.maintenance ? state.maintenance.maintenance : null,
  isBannerActive: state.maintenance ? state.maintenance.isBannerActive : false,
  bannerId: state.maintenance ? state.maintenance.bannerId : null,
});

export default connect(mapStateToProps)(MaintenanceBanner);
